<template>
<div id="app" ref="app">
  <div class="full-size grid-container" v-if="dataFormatValid() && $router.currentRoute.name != 'login' && $router.currentRoute.name != 'register'">
    <Sidebar @hide='hideSidebar(true)' ref='sidebar' />

    <router-view class='main'>
    </router-view>

  </div>
  <div class='full-size' v-else>
    <router-view class='main full-size'>
    </router-view>
  </div>
  <modal name="welcome" :height="425" :classes="['change-journal-modal', 'v--modal']">
    <div class="welcome-title">
      <h2>Welcome to Journalisr!</h2>
    </div>
    <div class="welcome-body-text" ref="welcomeText">
      Journalisr is here for all of your journalling needs. With it, you can:
      <ul>
        <li>Write for any day you want, past, present or future</li>
        <li>Experiment with markdown in your journal entries to add code snippets, images and lists and more</li>
        <li>Create as many different journals as you like</li>
        <li>Switch with ease and distinction, and give each journal customisable settings</li>
        <li>Stress less as it autosaves in the background while you type</li>
        <li>Enjoy instant reloading of all settings, entries and journals when you return</li>
      </ul>
    </div>
    <vue-button type="success" ref="welcomeButton" class="next-button" @click="nextWelcomeScreen()">
      Next →
    </vue-button>
  </modal>
</div>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
const md5 = require("blueimp-md5")
const debounce = require("lodash.debounce")
const throttle = require("lodash.throttle")
const hammer = require("hammerjs")
const classes = require("./assets/classes.js")

export default {
  name: 'app',
  components: {
    Sidebar
  },
  watch: {
    $route: function(n, o) {
      this.checkLogin(o)
      if (this.dataFormatValid()) {
        this.journal.purge(this.date.dateString())
      }
    }
  },
  data: function() {
    return {
      currentJournal: undefined,
      date: new Date(),
      autoOpenEditor: false,
      registrationComplete: false,
      isLocalVersion: true,
      welcomeScreen: 1
    }
  },
  computed: {
    loggedIn: function() {
      return true
      // return window.sessionStorage.getItem('loggedIn') ? true : false;
    },
    journal: function() {
      if (this.currentJournal == undefined && this.dataFormatValid()) {
        this.currentJournal = Object.keys(this.$root.data.journals)[0]
      }
      return this.$root.data.journals[this.currentJournal]
    }
  },
  created: function() {
    var root = this.$root;

    // get json for user from server/localStorage
    var fetchedData = window.localStorage.getItem('journalisr_store'),
      dataLoad = {}
    if (fetchedData != null) {
      try {
        dataLoad = JSON.parse(window.atob(fetchedData))
        console.log('Successfully loaded userData from cache.')
      } catch (e) {
        console.warn('Failed loading from cache.');
      }
    }
    // if (Object.keys(dataLoad).length == 0) {
    //   console.log('Loading user data from json file.');
    //   dataLoad = require('./sampledata/data_d06b3625-c338-5be3-bdd6-f14c868dd254.json')
    // }
    root.data = dataLoad || {}

    // define journals object if not existent yet
    if (root.data.journals == undefined) {
      root.data.journals = {}
    } else {
      // if provided, recreate as Entry classes and add journal obj back
      for (var journal in root.data.journals) {
        if (root.data.journals.hasOwnProperty(journal)) {
          root.data.journals[journal] = new classes.Journal(root.data.journals[journal])
        }
      }
    }

    // extend date object to provide TZ-proof date formatter
    Date.prototype.dateString = function() {
      var local = new Date(this);
      local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
      return local.toJSON().slice(0, 10);
    };


    this.checkLogin();
  },
  mounted: function() {
    var b = this;
    window.onresize = debounce(function() {
      if (window.innerWidth <= 768) {
        b.$root.isMobile = true;
      } else {
        b.$root.isMobile = false;
      }
    }, 400)
    window.onresize()

    // Detect swipes
    var hammertime = new hammer(this.$refs.app, {});
    hammertime.on('swipe', function(ev) {
      if (ev.direction == 2) {
        b.hideSidebar()
      } else if (ev.direction == 4) {
        b.hideSidebar(false)
      }
    });


    if (window.loginChecker) {
      clearInterval(window.loginChecker);
    }
    // window.loginChecker = setInterval(function() {
    //   b.checkLogin()
    // }, 5000);

    var b = this;
    window.jocli = function(arg, arg2) {
      var commands = {
        save: function() {
          b.forceSave()
          console.log('jocli - Save operation completed.');
        },
        dump: function() {
          console.log(window.btoa(JSON.stringify(b.$root.data)));
          console.log('jocli - Export operation complete.');
        },
        load: function(data) {
          var re = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/
          if (re.test(data)) {
            try {
              var newData = JSON.parse(window.atob(data))
              b.$root.data = newData;
              console.log('jocli - load data succeeded, reloading in 2 seconds.');
              setTimeout(function() {
                window.location.reload()
              }, 2000);
            } catch (e) {
              console.warn('jocli - load data failed, json error');
            }
          } else {
            console.warn('jocli - load data failed, invalid b64 string');
          }
        },
        reset: function() {
          console.log('jocli - reset order succeeded, reloading in 2 seconds.');
          setTimeout(function() {
            b.$root.data = {}
            window.localStorage.clear()
            window.sessionStorage.clear()
            window.location.reload()
          }, 2000);
        }
      }
      if (arg == undefined || !commands.hasOwnProperty(arg)) {
        console.log('Welcome to journalisr command line.\n\nAvailable commands:\n - save (force a save)\n - dump (encoded data)\n - load "data" (encoded data)\n - reset (erase all locally stored data)\n\nRun like this: jocli(command [, data])');
        return
      } else {
        commands[arg](arg2);
      }
    }

  },
  methods: {
    // login fucntions
    checkLogin(oldRoute) {
      // Check login
      var route = oldRoute || this.$router.currentRoute
      if (this.isLocalVersion && !this.dataFormatValid() && route.name != 'register') {
        this.$router.push({
          name: 'register'
        });
        return
      } else if (this.isLocalVersion) {
        return
      }
      if (window.sessionStorage.getItem('loggedIn') != this.createLoginHash() &&
        this.$router.currentRoute.name != 'login') {
        this.$router.push({
          name: 'login'
        });
      }
    },
    createLoginHash() {
      var currentdate = new Date();
      var datetime = currentdate.getDate() + "/" +
        (currentdate.getMonth() + 1) + "/" +
        currentdate.getFullYear() + " @ " +
        currentdate.getHours() + ":" +
        Math.floor(currentdate.getMinutes() / 15)

      return md5(btoa('valid' + datetime + 'valid'))
    },
    dataFormatValid() {
      var d = this.$root.data;
      // done like this as some statements further down will
      // cause errors if higher properties do not exist
      if (!d.hasOwnProperty('journals')) {
        return false
      }
      // if (!Object.keys(d.journals).length) {
      //   return false
      // }
      if (!d.hasOwnProperty("user")) {
        return false
      }
      if (!d.user.hasOwnProperty("name") || !d.user.hasOwnProperty("uuid")) {
        return false
      }

      return true
    },

    // data/journal functions
    autoSave: throttle(function() {
      // send to server/localStorage
      window.localStorage.setItem('journalisr_store', window.btoa(JSON.stringify(this.$root.data)))
    }, 5000),
    forceSave() {
      window.localStorage.setItem('journalisr_store', window.btoa(JSON.stringify(this.$root.data)))
    },
    createJournal(name, defaultText) {
      this.$root.data.journals[name] = new classes.Journal({
        name: name,
        ownerUUID: this.$root.data.user.uuid,
        defaultText: defaultText
      });
      this.autoSave()
    },

    // ui functions
    hideSidebar(hide = true) {
      if (hide) {
        this.$refs.sidebar.$el.classList.add('slide')
      } else {
        this.$refs.sidebar.$el.classList.remove('slide')
      }
    },
    openEditorToDate(date) {
      this.date = date;
      this.autoOpenEditor = true;
      this.$router.push({
        name: 'compose'
      })
    },
    nextWelcomeScreen() {
      if (this.welcomeScreen == 2) {
        this.$modal.hide('welcome')
      }
      this.welcomeScreen = 2;
      console.log(this.$refs.welcomeText.innerHTML);
      this.$refs.welcomeText.innerHTML = `
      Use the Composer ('New' in sidebar) to write entries.
      Use List View to see your most recent entries at a glance.
      Use Month View to see a broader view of your entries.
      Use Settings to export/backup/import your data.
      Use the Account page to change your name and view email address.
      `
      this.$refs.welcomeButton.$el.innerHTML = "Done ✔"
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,900|Open+Sans:300,400|Muli:300,600');

:root {
  /* ffffff-374d6b-283a59-22324d-232323 */
  /* --light: #ffffff;
  --shade0: #4e6d97;
  --shade1: #374d6b;
  --shade2: #283a59;
  --shade3: #22324d;
  --dark: #232323; */

  --text: var(--dark);
  --link: var(--shade1);
  --linkdark: var(--shade2);
}

a:visited,
a {
  color: var(--link);
  text-decoration: none;
}

a:hover {
  color: var(--linkdark);
  text-decoration: underline;
}

body {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  margin: 0;
  color: var(--text);
  padding: 0;
  line-height: 1.5;
  width: 100%;
  height: 100%;
}

html,
body,
#app,
.full-size {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.center-flex {
  display: grid;
  justify-content: center;
  align-items: center;
}

.grid-container {
  display: grid;
  grid-template-columns: 225px minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  grid-template-areas: "sidebar main";
  /* background: var(--light); */
}

.sidebar {
  grid-area: sidebar;
}

.main {
  grid-area: main;
}

.footer {
  font-size: 8pt;
  color: var(--medium);
  line-height: 3em;
  bottom: 0;
}

hr {
  border: none;
  border-bottom-color: var(--light);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}

@media only screen and (max-width: 768px) {
  .grid-container {
    display: block;
  }

  .sidebar {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    transition: left 0.15s ease-in;
  }

  .sidebar.slide {
    left: -100%;
    transition: left 0.25s ease-out;
  }

  .sidebar>.footer {
    width: 100%;
  }

  .main {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
  }
}


/* modal stuff */
.welcome-title {
  color: #3b3b3b;
  padding: 15px;
  height: 37px;
  border-bottom: 1px solid grey;
  cursor: default;
  border-bottom: 2px solid dimgrey;

}

.welcome-title>h2 {
  margin: 0px;
  font-size: 25px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.welcome-body-text {
  padding: 15px;
}

.next-button {
  float: right;
  margin-right: 20px !important;
}
</style>
